var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { $ } from 'hanako-ts/dist-legacy/Framework';
import { Component } from 'hanako-ts/dist-legacy/Component';
export class Header extends Component {
    constructor() {
        super('Header', false);
    }
    init() {
        const _super = Object.create(null, {
            init: { get: () => super.init }
        });
        return __awaiter(this, void 0, void 0, function* () {
            yield _super.init.call(this);
            $('.btn-toggle-search-bar').on('click', (event) => {
                event.preventDefault();
                const timeout = $('#search-bar').hasClass('d-none') ? 0 : 500;
                setTimeout(() => {
                    $('#search-bar').toggleClass('d-none');
                    if (!$('#search-bar').hasClass('d-none')) {
                        $('#search-bar input').get(0).focus();
                    }
                }, timeout);
                setTimeout(() => {
                    $('#search-bar').toggleClass('appear');
                }, 100);
            });
            $(window).on('resize', () => {
                this.resize();
            });
            this.resize();
            this.success();
        });
    }
    resize() {
        $('#search-bar').removeClass('d-none').addClass('is-resizing');
        $('#search-bar').css('--max-width', $('#search-bar form *').elements.reduce((value, item) => value + $(item).width(), 0) + 'px');
        $('#search-bar').addClass('d-none').removeClass('is-resizing');
    }
}
